import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('../views/Dashboard.vue'),
      meta: { title: '仪表盘' }
    },
    {
      path: '/focus',
      name: 'focus',
      component: () => import('../views/Focus.vue'),
      meta: { title: '今日专注' }
    },
    {
      path: '/pending',
      name: 'pending',
      component: () => import('../views/Pending.vue'),
      meta: { title: '待处理' }
    },
    {
      path: '/completed',
      name: 'completed',
      component: () => import('../views/Completed.vue'),
      meta: { title: '已完成' }
    },
    {
      path: '/archived',
      name: 'archived',
      component: () => import('../views/Archived.vue'),
      meta: { title: '归档' }
    },
    {
      path: '/tags',
      name: 'tags',
      component: () => import('../views/Tags.vue'),
      meta: { title: '标签' }
    }
  ]
});

// 更新页面标题
router.beforeEach((to, from, next) => {
  const title = to.meta.title || 'SnapClip';
  document.title = `${title} - SnapClip`;
  next();
});

export default router;
